import { render, staticRenderFns } from "./ProfileMyProfileEditPinModal.vue?vue&type=template&id=20f46f93&scoped=true&"
import script from "./ProfileMyProfileEditPinModal.vue?vue&type=script&lang=ts&"
export * from "./ProfileMyProfileEditPinModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f46f93",
  null
  
)

export default component.exports